// extracted by mini-css-extract-plugin
module.exports = {"root":"NominateAmbassador_root__2rW0X","text":"NominateAmbassador_text__2pBxE","title":"NominateAmbassador_title__2Twpm"};